import React from 'react';
import {
	BaasicInput,
	BaasicSelect,
	DatePicker,
	BaasicCheckbox,
	Loader,
	BaasicHeader,
	BaasicDropdown,
} from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';
import { receivingStatus } from 'common/constants';

const ReceivingEditTemplate = ({ receivingEditViewStore, t }) => {
	const {
		form,
		warehouseOptions,
		receivingStatusOptions,
		receivingTypeOptions,
		productOptions,
		onWarehouseChange,
		onProductChange,
		onReceivingStatusChange,
		onReceivingTypeChange,
		rootStore,
		addProduct,
		onDelete,
		dateFormat,
		loading,
		isEdit,
		isReceivedStatus,
		isIncomingStatus,
		isArrivedAtPortStatus,
		showWarningMessage,
		isSeller,
		isSuperAdmin,
		onCheck,
		isReceivingProductCheckboxDisabled,
		isInTransitStatus,
		isTransfer,
		handleWarehouseOnScroll,
		handleProductsOnScroll,
		onMenuCloseWarehouse,
		throttleOnMenuClose,
		debouncedWarehouseSearch,
		debouncedProductsSearch,
		isWarehouseDropdownLoading,
		isProductsDropdownLoading,
		previousStatus,
		actualReceivingDateWithTime,
		sellerDropdownStore,
	} = receivingEditViewStore;
	if (loading) return <Loader />;
	return (
		<section>
			<BaasicHeader title="CONTAINERFORM.TITLE" rootStore={rootStore} />
			<form className="container--dashboard" onSubmit={form.onSubmit}>
				<div className="row">
					<div className="col col-sml-12 col-xxlrg-10">
						<div className="spc--bottom--sml">
							{isSuperAdmin && (
								<BaasicDropdown
									dropdownStore={sellerDropdownStore}
									placeholder={t('PLACEHOLDER.SELLER')}
									className="w--200--px spc--right--sml"
									isDisabled={isEdit}
								/>
							)}
						</div>
						<div className="row spc--bottom--sml">
							<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
								<BaasicSelect
									field={form.$('receivingType')}
									options={receivingTypeOptions.slice()}
									value={form.$('receivingType').value}
									onChange={value => onReceivingTypeChange(value, form.$('receivingType'))}
									isDisabled={isEdit || isReceivedStatus || (!isSeller && !isSuperAdmin && isArrivedAtPortStatus)}
									isClearable={false}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
								<BaasicSelect
									field={form.$('warehouseTo')}
									options={warehouseOptions.slice()}
									value={form.$('warehouseTo').value}
									isClearable={true}
									onChange={value =>
										onWarehouseChange(value, form.$('warehouseTo'), form.$('warehouseFrom'), false, true)
									}
									disabled={
										isEdit ||
										isIncomingStatus ||
										isReceivedStatus ||
										(!isSeller && !isSuperAdmin) ||
										isInTransitStatus ||
										(isTransfer && isEdit)
									}
									onMenuScrollToBottom={handleWarehouseOnScroll}
									onMenuClose={onMenuCloseWarehouse}
									isLoading={isWarehouseDropdownLoading}
									onInputChange={debouncedWarehouseSearch}
								/>
							</div>
							{isTransfer && (
								<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
									<BaasicSelect
										field={form.$('warehouseFrom')}
										options={warehouseOptions.slice()}
										value={form.$('warehouseFrom').value}
										isClearable={true}
										onChange={value =>
											onWarehouseChange(value, form.$('warehouseTo'), form.$('warehouseFrom'), true, false)
										}
										disabled={
											isEdit ||
											isIncomingStatus ||
											isReceivedStatus ||
											(!isSeller && !isSuperAdmin) ||
											isInTransitStatus ||
											(isTransfer && isEdit)
										}
										onMenuScrollToBottom={handleWarehouseOnScroll}
										onMenuClose={onMenuCloseWarehouse}
										isLoading={isWarehouseDropdownLoading}
										onInputChange={debouncedWarehouseSearch}
									/>
								</div>
							)}
						</div>
						<div className="row">
							<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
								{showWarningMessage && (
									<p className="type--color--note spc--bottom--sml">{t('CONTAINERFORM.NOTIFICATIONS.WARNING')}</p>
								)}
								<BaasicSelect
									isDisabled={!isEdit || isReceivedStatus || (!isSeller && !isSuperAdmin && isArrivedAtPortStatus)}
									field={form.$('receivingStatus')}
									options={receivingStatusOptions}
									value={form.$('receivingStatus').value}
									onChange={value => onReceivingStatusChange(value, form.$('receivingStatus'))}
									className="spc--bottom--sml flex--grow--1"
								/>
							</div>
							<div className="col col-sml-12 col-lrg-6">
								<BaasicInput field={form.$('ref')} />
							</div>
							<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
								<DatePicker
									field={form.$('estimatedReceivingDate')}
									format={dateFormat}
									disabled={isReceivedStatus}
									showValidation={false}
								/>
							</div>
							{actualReceivingDateWithTime != null && (
								<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
									<DatePicker
										field={form.$('actualReceivingDate')}
										format={dateFormat}
										disabled={true}
										showValidation={false}
									/>
								</div>
							)}

							{isTransfer && (
								<div className="col col-sml-12 col-lrg-6 spc--bottom--sml">
									<BaasicInput field={form.$('cost')} />
								</div>
							)}
						</div>

						<h2 className="spc--bottom--sml">{t('CONTAINERFORM.CONTAINERPRODUCTS')}</h2>
						{form.$('products').map(product => {
							return (
								<div className="box--secondary box--sml spc--bottom--sml" key={product.id}>
									{!isReceivedStatus && !isInTransitStatus && !isArrivedAtPortStatus && !product.$('isReceived').value && (
										<div className="box--secondary__close">
											<button
												className="btn btn--med btn--ghost react-filter-box-close"
												onClick={e => onDelete(e, product)}
												type="button"
											>
												<i className="fa fa-times"></i>
											</button>
										</div>
									)}
									<div className="row">
										<div className="col col-sml-3">
											<div className="inputgroup">
												<BaasicSelect
													field={product.$('selectedProduct')}
													value={product.$('selectedProduct').value}
													isDisabled={
														isReceivedStatus ||
														isInTransitStatus ||
														product.$('isReceived').value ||
														isArrivedAtPortStatus
													}
													options={productOptions.slice()}
													onMenuClose={throttleOnMenuClose}
													onInputChange={debouncedProductsSearch}
													onChange={value => onProductChange(value, product.$('selectedProduct'))}
													onMenuScrollToBottom={handleProductsOnScroll}
													isLoading={isProductsDropdownLoading}
												/>
											</div>
										</div>
										<div className="col col-sml-3">
											<BaasicInput
												field={product.$('quantity')}
												disabled={
													isReceivedStatus ||
													isInTransitStatus ||
													product.$('isReceived').value ||
													isArrivedAtPortStatus
												}
											/>
										</div>
										<div className="col col-sml-3">
											<BaasicInput field={product.$('description')} />
										</div>
										{isEdit && (
											<div className="col col-sml-3">
												<div className="input--toggle--custom">
													<BaasicCheckbox
														id={product.$('isReceived').id}
														label={'CONTAINERFORM.ISRECEIVED'}
														onChange={evt => onCheck(evt, product.$('isReceived'))}
														checked={product.$('isReceived').value}
														disabled={
															isReceivingProductCheckboxDisabled(product.$('id').value) ||
															!isSeller ||
															(!isInTransitStatus && isTransfer) ||
															isIncomingStatus ||
															previousStatus.extra.abrv === receivingStatus.pendingPickup
														}
													/>
												</div>
											</div>
										)}
									</div>
								</div>
							);
						})}
						<div className="spc--bottom--sml">
							<button
								className="btn btn--med btn--primary spc--right--sml spc--bottom--sml"
								type="submit"
								disabled={form.$('products').value == undefined}
							>
								{t('SAVE')}
							</button>

							<button
								className="btn btn--med btn--secondary spc--bottom--sml"
								type="button"
								onClick={addProduct}
								disabled={isInTransitStatus || isReceivedStatus || isArrivedAtPortStatus}
							>
								<i className="fa fa-plus spc--right--sml"></i>
								{t('CONTAINERFORM.ADDPRODUCT')}
							</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(ReceivingEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/ReceivingEditTemplate.jsx